import React from "react";
import { Box, Typography } from "@mui/material";

// Add props to the component signature
const DynamicWidthToggleSwitchWithText = ({ checked, onChange }) => {
  const toggleSwitch = () => {
    // Call the onChange function passed from the parent
    onChange(!checked);
  };

  const trackColor = checked ? "success.main" : "error.main";
  const thumbWidth = 22;
  const thumbPosition = checked ? `calc(100% - ${thumbWidth}px - 3px)` : "3px";

  return (
    <Box
      sx={{
        width: 90,
        height: 28,
        borderRadius: "20px",
        bgcolor: trackColor,
        position: "relative",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        p: 0.5,
        transition: "background-color 0.3s ease",
      }}
      onClick={toggleSwitch}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          left: thumbPosition,
          width: thumbWidth,
          height: thumbWidth,
          borderRadius: "50%",
          bgcolor: "white",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          transition: "left 0.3s ease",
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: "white",
          fontWeight: "bold",
          position: "absolute",
          left: checked ? "5px" : "28px",
          transition: "left 0.3s ease, opacity 0.3s ease",
          opacity: checked ? 0 : 1,
          whiteSpace: "nowrap",
        }}
      >
        INACTIVE
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: "white",
          fontWeight: "bold",
          position: "absolute",
          left: checked ? "18px" : "5px",
          transition: "left 0.3s ease, opacity 0.3s ease",
          opacity: checked ? 1 : 0,
          whiteSpace: "nowrap",
        }}
      >
        ACTIVE
      </Typography>
    </Box>
  );
};

export default DynamicWidthToggleSwitchWithText;
